export default __webpack_public_path__ + "static/media/serviceagentimportsample.1b4707fd.xlsx";